import { useMutation, useQueryClient } from "@tanstack/react-query";

import { VoucherAssignmentQueries } from "./queries";
import {
  createCartVoucherAssignment,
  postVoucherLookup,
  removeCartVoucherAssignment,
} from "./requests";

export const useVoucherLookup = () => {
  return useMutation({
    mutationFn: postVoucherLookup,
  });
};

export const useCreateCartVoucherAssignment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createCartVoucherAssignment,
    onSuccess: (data) => {
      queryClient.setQueryData(
        VoucherAssignmentQueries.all(data.cartUuid).queryKey,
        (old) => {
          if (!old) return [data];
          return [...old, data];
        },
      );
    },
  });
};

export const useRemoveCartVoucherAssignment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: removeCartVoucherAssignment,
    onSuccess: (data) => {
      // Invalidate any queries that may have used this assignment
      queryClient.setQueryData(
        VoucherAssignmentQueries.all(data.cartUuid).queryKey,
        (old) => {
          if (!old) return [];
          return old.filter((assignment) => assignment.uuid !== data.uuid);
        },
      );
    },
  });
};
